module.exports = __webpack_public_path__ + "img/paas_wrapbg2.af0c92dd.png";